export type RegionStatus = 'unvisited' | 'wishlist' | 'planned' | 'visited' | 'revisit';
export type Visibility = 'private' | 'public';
export type PlaceKind = 'attraction' | 'food';

export type User = {
  id: string;
  email: string;
  displayName: string;
  avatarUrl: string | null;
  publicSlug: string;
  bio: string;
  isProfilePublic: boolean;
};

export type Region = {
  id: string;
  name: string;
  shortName: string;
  mapGroup: string;
  description: string;
  recommendedMonths: number[];
  themes: string[];
  minDays: number;
  sortOrder: number;
};

export type Place = {
  id: string;
  regionId: string;
  kind: PlaceKind;
  name: string;
  subtitle: string;
  themes: string[];
  recommendedMonths: number[];
  isSeed: boolean;
  sortOrder: number;
};

export type RegionProgress = {
  regionId: string;
  status: RegionStatus;
  rating: number | null;
  lastVisitedOn: string | null;
  review: string;
  privateNote: string;
  companionTags: string[];
  visibility: Visibility;
  isNextCandidate: boolean;
  updatedAt?: string;
};

export type PlaceProgress = {
  placeId: string;
  isChecked: boolean;
  rating: number | null;
  visitedOn: string | null;
  review: string;
  privateNote: string;
  companionTags: string[];
  visibility: Visibility;
  updatedAt?: string;
};

export type PlanItem = {
  id?: string;
  dayIndex: number;
  startTime: string | null;
  placeId: string | null;
  title: string;
  notes: string;
  sortOrder: number;
};

export type TravelPlan = {
  id: string;
  regionId: string | null;
  title: string;
  startDate: string;
  endDate: string;
  theme: string;
  notes: string;
  status: 'draft' | 'confirmed' | 'completed';
  visibility: Visibility;
  items: PlanItem[];
  createdAt?: string;
  updatedAt?: string;
};

export type BootstrapData = {
  user: User;
  regions: Region[];
  places: Place[];
  regionProgress: RegionProgress[];
  placeProgress: PlaceProgress[];
  plans: TravelPlan[];
};

export type Meta = {
  appName: string;
  environment: string;
  devAuthEnabled: boolean;
};

export const emptyRegionProgress = (regionId: string): RegionProgress => ({
  regionId,
  status: 'unvisited',
  rating: null,
  lastVisitedOn: null,
  review: '',
  privateNote: '',
  companionTags: [],
  visibility: 'private',
  isNextCandidate: false,
});

export const emptyPlaceProgress = (placeId: string): PlaceProgress => ({
  placeId,
  isChecked: false,
  rating: null,
  visitedOn: null,
  review: '',
  privateNote: '',
  companionTags: [],
  visibility: 'private',
});
